module.exports = __webpack_public_path__ + "img/icon-word-logo.6f18095f.png";